import ToggleBox from '@/components/Common/ToggleBox';

export default {
  name: 'FeatureTile',

  components: { ToggleBox },

  props: {
    service: {
      type: Object,
      default: (() => { })
    },
    hide_price: {
      type: Boolean,
      default: (() => true)
    }
  },

  data() {
    return {
      arrow: require("@/assets/arrow-up.svg"),
      expanded: false,
    };
  },

  computed: {
    statusMessage() {
      if (this.service.is_active) {
        return 'AKTYWNA';
      } else {
        return '';
      }
    },
    expandLabel() {
      if (this.expanded) {
        return 'Zwiń szczegóły';
      } else {
        return 'Pokaż szczegóły';
      }
    },
    title() {
      return this.service.label;
    },
    subtitle() {
      return this.service.short_description;
    },
    description() {
      return this.service.description;
    },
    charge() {
      return this.service.charge;
    },
    toggleable() {
      return this.service.is_toggleable;
    },
    active() {
      return this.service.is_active;
    }
  },

  methods: {
    toggleDescription() {
      this.expanded = !this.expanded;
    },
    showPacketActivation() {
      this.$EventBus.$emit('Service/TOGGLE_MODAL_WITH_STATUS_CHANGE', this.service);
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/Services/FeatureTile/component.js